/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Permessi extra per singolo utente. Permessi previsti:   -*GESTIONE_OPERATORI_COMUNE*: un OP_COMUNE gestisce gli altri operatori comunali dei suoi comuni  -*GESTIONE_CALENDARIO_MENSA*: un OP_COMUNE modifica il calendario mensa (assenze, pasta in bianco) degli studenti dei suoi comuni, come l\'operatore scuola
 */
export enum Permesso {

    GESTIONE_OPERATORI_COMUNE = 'GESTIONE_OPERATORI_COMUNE',

    GESTIONE_CALENDARIO_MENSA = 'GESTIONE_CALENDARIO_MENSA'
}

